import React, { useContext, useState } from 'react';
import { StateContext } from '../../StateContext';
import axios from 'axios';
import furball from 'wa-furball';
import { fetchAllData } from '../../../utils';
import {
    Modal,
    Button,
    Box,
    TextField,
    InputLabel,
    MenuItem,
    Select,
    FormControl,
} from '@mui/material';
import { boxStyle } from '../Projects/styles';
import { Urls } from '../../../Urls';
import { addMechanicCall } from '../../Services/APICalls/apicalls';
import { MechanicTypes, getMechanicTypeLabel } from '../../Services/types';
import { useLanguage } from '../../Services/LanguageContext';

const AddMechanic = () => {
    const [mechanicName, setMechanicName] = useState('');
    const [type, setType] = useState<string | number>(MechanicTypes[0].value);
    const [about, setAbout] = useState('');
    const [open, setOpen] = useState(false);
    const { t, language } = useLanguage();

    const { loginData, setLoginData } = useContext(StateContext);

    const defaultWeight = MechanicTypes.find((x) => x.value === type)?.weight || 100;

    const addMechanicHandler = () => {
        addMechanicCall(mechanicName, about, type, defaultWeight, setLoginData);
        setOpen(false);
        setMechanicName('');
        setAbout('');
        return;
    };

    return (
        <React.Fragment>
            <Button
                variant='outlined'
                color='success'
                onClick={() => setOpen(true)}
            >
                {t('addMechanic')}
            </Button>
            <Modal
                open={open}
                onClose={() => setOpen(false)}
                aria-labelledby='modal-modal-title'
                aria-describedby='modal-modal-description'
            >
                <Box style={boxStyle}>
                    <form
                        onSubmit={addMechanicHandler}
                        action='#'
                        className='flex flex-col items-center gap-3'
                        style={{ width: '100%' }}
                    >
                        <TextField
                            type='text'
                            label={t('name')}
                            variant='outlined'
                            fullWidth
                            value={mechanicName}
                            onChange={(x) => setMechanicName(x.target.value)}
                        />
                        <FormControl fullWidth>
                            <InputLabel id='mechanic-type-select-label'>
                                {t('type')}
                            </InputLabel>
                            <Select
                                label={t('type')}
                                labelId='mechanic-type-select-label'
                                id='mechanic-type-select'
                                value={type}
                                onChange={(x) => setType(x.target.value)}
                            >
                                {MechanicTypes.map((type) => (
                                    <MenuItem
                                        key={type.value}
                                        value={type.value}
                                    >
                                        {getMechanicTypeLabel(type.value, language)}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        <TextField
                            type='text'
                            id='outlined-multiline-static'
                            label={t('notes')}
                            multiline
                            rows={4}
                            variant='outlined'
                            fullWidth
                            defaultValue={t('typeRemarksHere')}
                            value={about}
                            onChange={(x) => setAbout(x.target.value)}
                        />
                        <button
                            style={{ width: '100%' }}
                            onClick={addMechanicHandler}
                        >
                            {t('add')}
                        </button>
                    </form>
                </Box>
            </Modal>
        </React.Fragment>
    );
};

export default AddMechanic;

// setLoginData({
//   ...loginData,
//   mechanics: [...loginData.mechanics, response.data],
// }
